const Facebook = () => {
    return (  
        // <svg>
        //     <defs>
        //         <linearGradient x1="50%" x2="50%" y1="97.0782153%" y2="0%" id="jc_2">
        //             <stop offset="0%" stopColor='#ffffff'></stop>
        //             <stop offset="100%" stopColor='#ffffff'></stop>
        //         </linearGradient>
        //     </defs>
        //     <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z"></path>
        //     <path fill='#85ba84' d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"></path>
        // </svg>  
        
        
        <svg width="46px" height="46px" viewBox="0 0 24 24" id="_24x24_On_Light_Facebook" data-name="24x24/On Light/Facebook" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="0.991" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#ffffff"/>
                <stop offset="1" stop-color="#ffffff"/>
                </linearGradient>
                <clipPath id="clip-path">
                <path id="Shape" d="M11.193,19.929h0V13.159h2.358l.354-2.667H11.193v-1.7c0-.779.231-1.3,1.356-1.3H14V5.106A19.937,19.937,0,0,0,11.887,5,3.269,3.269,0,0,0,8.365,8.525v1.966H6v2.667H8.365v6.709a10,10,0,1,1,2.83.062Z" transform="translate(2 2)" fill="url(#linear-gradient)"/>
                </clipPath>
            </defs>
            <rect id="view-box" width="24" height="24" fill="none"/>
            <path id="Shape-2" data-name="Shape" d="M11.193,19.929h0V13.159h2.358l.354-2.667H11.193v-1.7c0-.779.231-1.3,1.356-1.3H14V5.106A19.937,19.937,0,0,0,11.887,5,3.269,3.269,0,0,0,8.365,8.525v1.966H6v2.667H8.365v6.709a10,10,0,1,1,2.83.062Z" transform="translate(2 2)" fill="url(#linear-gradient)"/>
        </svg>
    );
}
 
export default Facebook;